import { useEffect, useState } from 'react';
import productPriceApi from '@apis/productPrice';
import { useDebounce } from '@hooks/useDebounce';
import { IFilterProductPrice } from '@type/productPrice';
import { IProductCustomPrice } from '../ProductPriceTable';
import { ESortOrder } from '@type/product';
import { IFilter } from '@type/param';

export function useProductPriceTable(userId?: string) {
  const [productPrice, setProductPrice] = useState<IProductCustomPrice[]>([]);
  const [totalData, setTotalData] = useState(0);

  const [filters, setFilters] = useState<IFilter<IFilterProductPrice>>({
    limit: 10,
    page: 1,
    sort: 'updatedAt',
    order: ESortOrder.Asc,
    filters: { userId: userId || '' },
  });

  const [search, setSearch] = useState('');
  const searchDebounce = useDebounce(search, 500);

  // Fetch product list
  useEffect(() => {
    if (!userId) return;
    productPriceApi
      .getListPagination({
        ...filters,
        keyword: searchDebounce,
        filters: { ...filters.filters, userId },
      })
      .then(({ data }) => {
        setProductPrice(data?.data || []);
        setTotalData(data?.totalData || 0);
      })
      .catch(() => {
        setProductPrice([]);
        setTotalData(0);
      });
  }, [filters, searchDebounce, userId]);

  const refreshList = () => {
    setFilters((prev) => ({ ...prev }));
  };

  return {
    productPrice,
    totalData,
    filters,
    setFilters,
    search,
    setSearch,
    refreshList,
  };
}
